module.exports = __webpack_public_path__ + "img/fixing-bugs.e3f86f3f.svg";